import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arblockbot',
  templateUrl: './arblockbot.component.html',
  styleUrls: ['./arblockbot.component.scss']
})
export class ArblockbotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
